// Header.js
import React, {useContext} from 'react';
import {MyContext} from '../Actions/UAuth'

function Header() {
  const {rootState,logoutUser} = useContext(MyContext);
  const {theUser} = rootState;         
      let base =process.env.PUBLIC_URL;
      let tpbase ='#';
        return ( 
   <header className="main-header">            
    <a href={base} className="logo">     
      <span className="logo-mini"><b>W</b>MS</span>     
      <span className="logo-lg"><b>WMS</b></span>
    </a>
    <nav className="navbar navbar-static-top" role="navigation">    
    <a href={tpbase} className="sidebar-toggle" data-toggle="push-menu" role="button">
           <span className="sr-only"></span>
    </a>    
		<a href={base} className="navbar-brand">               
        <h3 style={{ marginTop:'-13px'}}>Works Monitoring System</h3>
				<h5>Goverment of Gujarat</h5>
    </a>
          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="dropdown messages-menu">
                <a href={base} className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-envelope-o"></i>
                  <span className="label label-success gettotalunreadmail">0</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="header">You have <span className="gettotalunreadmail"></span> messages</li>
                  <li></li>
                  <li className="footer"><a href={base}>See All Messages</a></li>
                </ul>
              </li>
              <li className="dropdown tasks-menu">
                <a href={base} className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-flag-o"></i>
                  <span className="label label-danger">3</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="header">You have 3 tasks</li>
                  <li>
                    <ul className="menu">
                      <li>
                        <a href={base}>
                          <h3>
                            TOTAL COMPLETED PARTWORK
                            <small className="pull-right">0%</small>
                          </h3>
                          <div className="progress xs">
                            <div className="progress-bar progress-bar-aqua" style={{ width:'100%'}} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                              <span className="sr-only">0% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a href={base}>
                          <h3>
                            TOTAL IN PROGRESS PARTWORK
                            <small className="pull-right">%</small>
                          </h3>
                          <div className="progress xs">
                            <div className="progress-bar progress-bar-green" style={{ width: '100%'}} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                              <span className="sr-only">% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a href={base}>
                          <h3>
                            TOTAL NOT STARTED PARTWORK
                            <small className="pull-right">%</small>
                          </h3>
                          <div className="progress xs">
                            <div className="progress-bar progress-bar-red" style={{ width: '100%'}} role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                              <span className="sr-only">% Complete</span>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="footer">
                    <a href={base}>View all tasks</a>
                  </li>
                </ul>
              </li>
              <li className="dropdown user user-menu">
                <a href={base} className="dropdown-toggle" data-toggle="dropdown">
                <img className="user-image" src={`${base}/asset/dist/img/avatar5.png`} alt="logo"/>
                  <span className="hidden-xs"></span>
                </a>
                <ul className="dropdown-menu">
                  <li className="user-header">
                  <img className="image-circle" src={`${base}/asset/dist/img/avatar5.png`} alt="logo"/>
                    
                    <h4>{theUser.user_name}</h4>                       
                      <small>{theUser.email}</small>
                    
                  </li>
                  <li className="user-footer">
                    <div className="pull-right">
                      <a href={base} onClick={logoutUser} className="btn btn-success btn-flat">Sign out</a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>
        )
    }
export default Header;